import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ug',
    fullName: 'Uyghur',
    nativeName: 'ئۇيغۇرچە',
    direction: 'rtl'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "ھەيران قالارلىق بىر ئىش كېلىدۇ",
    landing_subtitle: "ArgVoid بىر ئەپ ۋە ئويۇن ئېچىش ستۇدىيىسى. دىققەت قىلىڭ ، پات يېقىندا يېڭى ئىشلار كېلىدۇ!",
    select_language: "تىل تاللاڭ",
    search_placeholder: "ئىزدەش تىللىرى ...",
    terms_title: "مۇلازىمەت شەرتلىرى",
    policy_title: "مەخپىيەتلىك تۈزۈمى",
    cookies_title: "ساقلانما سىياسىتى",
    terms_content: `
        <strong>1. </strong><br> شەرتلىرىنى قوبۇل قىلىش
        ArgVoid نى زىيارەت قىلىش ئارقىلىق ، بۇ مۇلازىمەت شەرتلىرى قوبۇل قىلىنىدۇ. ئەگەر بۇ شەرتلەر قوشۇلمىسا ، مۇلازىمەتنى ئىشلىتىشكە بولمايدۇ. <br><br>

        <strong>2. سۇپا ئىشلىتىش </strong><br>
        ArgVoid ۋە ئۇنىڭ قوللىنىشچان پروگراممىلىرى ئۇچۇر ۋە ئىجادىي مەقسەتلەر ئۈچۈن تەمىنلەنگەن. بۇ مۇلازىمەتنى پەقەت قانۇنلۇق مەقسەتتە ئىشلىتىش كېرەك .<br><br>

        <strong>3. چەكلەنگەن ھەرىكەت </strong><br>
        تور بېكەتنىڭ يوچۇقلىرىنى ئېچىش ، ئەخلەت خەت يوللاش ياكى ئۇل ئەسلىھەگە رۇخسەتسىز كىرىشكە ئۇرۇنۇش قەتئىي مەنئى قىلىنىدۇ. <br><br>

        <strong>4. Disclaimer</strong><br>
        سۇپا ۋە مۇلازىمەتلەرنى خالىغان ۋاقىتتا ئۆزگەرتكىلى بولىدۇ. مۇلازىمەتنىڭ ۋاقتى ۋە تەمىناتىغا كاپالەتلىك قىلىنمايدۇ.
    `,
    policy_content: `
        <strong>1. ئۇچۇر توپلاش </strong><br>
        بۇ سۇپا ھازىرچە ئىشلەتكۈچىنىڭ سالاھىيىتىنى دەلىللەش ياكى ھېسابات قۇرۇشنى تەلەپ قىلمايدۇ. شەخسىي سالاھىيەت ئۇچۇرى (ئىسىم ياكى ئېلېكترونلۇق خەت ئادرېسى دېگەندەك) زىيارەتچىلەردىن ئاكتىپلىق بىلەن توپلانمايدۇ. <br><br>

        <strong>2. ئىشلىتىش Data</strong><br>
        تور بېكەت ئېقىمىنى چۈشىنىش ۋە قوللىنىشچان پروگراممىلارنى ياخشىلاش ئۈچۈن ئاساسىي ، نامسىز ئانالىزلار توپلىنىشى مۇمكىن. بۇ سانلىق مەلۇمات شەخسىي ئىشلەتكۈچى كىملىكى بىلەن باغلانمايدۇ .<br><br>

        <strong>3. ئۈچىنچى تەرەپ مۇلازىمىتى </strong><br>
        ئۈچىنچى تەرەپ تەمىنلىگۈچىلەر ساھىبخانلىق ۋە ئانالىز مۇلازىمىتى ئۈچۈن ئىشلىتىلىشى مۇمكىن. بۇ مۇناسىۋەتلىك تەمىنلىگۈچىلەرنىڭ مەخپىيەتلىك مەشغۇلاتلىرى ئۇلارنىڭ ئۇل ئەسلىھەلىرىدە بىر تەرەپ قىلىنغان نامسىز سانلىق مەلۇماتلارنى باشقۇرىدۇ. <br><br>

        <strong>4. Data Security</strong><br>
        سۇپىنى قوغداش ئۈچۈن مۇۋاپىق بىخەتەرلىك تەدبىرلىرى يولغا قويۇلدى. قانداقلا بولمىسۇن ، توردا ھېچقانداق يەتكۈزۈش ئۇسۇلى پۈتۈنلەي بىخەتەر ئەمەس. <br><br>
    `,
    cookies_content: `
        <strong>1. Cookies ۋە يەرلىك ساقلاش دېگەن نېمە؟ </strong><br>
        ساقلانمىلار ۋە توركۆرگۈچنىڭ يەرلىك ساقلىغۇچلىرى زىيارەت جەريانىدا سەپلىمە مايىللىقىنى ئەستە ساقلاش ئۈچۈن ئۈسكۈنىدە ساقلانغان كىچىك سانلىق مەلۇمات ھۆججەتلىرى. <br><br>

        <strong>2. ئىشلىتىش مەقسىتى </strong><br>
        توركۆرگۈ LocalStorage سەپلىمە تەڭشىكىنى ساقلاش ئۈچۈن قاتتىق ئىشلىتىلىدۇ ، مەسىلەن: <br>
        - تىل ئەۋزەللىكى <br>
        - ئىشلەتكۈچى كۆرۈنمە يۈزى سەپلىمىسى (مەسىلەن ، ئورۇنلاشتۇرۇش ياكى باشتېما تەڭشىكى) <br>
        - ۋاقىتلىق قوللىنىشچان پروگرامما cache<br><br>

        <strong>3. ئىز قوغلاش </strong><br> يوق
        ساقلانما ۋە يەرلىك ساقلاش ئېلان ياكى ئۈچىنچى تەرەپ ئىز قوغلاش مەقسىتىدە ئىشلىتىلمەيدۇ. ساقلانغان بارلىق سانلىق مەلۇماتلار سۇپىنىڭ يادرولۇق ئىقتىدارى ئۈچۈندۇر. <br><br>

        <strong>4. Control</strong><br>
        توركۆرگۈ سانلىق مەلۇماتلىرىنى توركۆرگۈ تەڭشىكى ئارقىلىق خالىغان ۋاقىتتا تازىلىغىلى بولىدۇ ، بۇ يەرلىك تەڭشەكلەرنى ئەسلىگە كەلتۈرىدۇ.
    `,
    cookie_consent_text: "بىز ئاساسىي ساقلانمىلارنى ئىشلىتىپ توربېكەتنىڭ ئىقتىدارىغا كاپالەتلىك قىلىمىز ، مەسىلەن ئولتۇرۇشىڭىزنى ئاكتىپلاشتۇرۇش ، تىلىڭىزنى ياقتۇرۇش ۋە باشقا ئىختىيارى تەڭشەكلەر.",
    read_policy: "Cookies سىياسىتىنى ئوقۇڭ",
    support_title: "ياردەم بىلەن ئالاقىلىشىڭ",
    support_subject_label: "تېما",
    support_message_label: "ئۇچۇر",
    support_submit_button: "ئۇچۇر ئەۋەتىش",
    support_hint: "ئەسكەرتىش: بۇ ئۇچۇر ئەۋەتىش ئۈچۈن سۈكۈتتىكى ئېلېكترونلۇق خەت پروگراممىڭىزنى ئاچىدۇ.",
    support_success_msg: "ئېلېكترونلۇق خەت ئەپىڭىزنى ئېچىش ...",
    support_error_msg: "ئۇچۇر ئەۋەتەلمىدى. كېيىن قايتا سىناڭ.",
    explorer_title: "Explorer",
    history_title: "تارىخ",
    animation_title: "Animation",
    config_title: "سەپلىمىسى",
    tool_mouse: "تاللاڭ (Ctrl + M)",
    tool_brush: "Brush (Ctrl + B)",
    tool_brush_mode: "Toggle Mode (قاتتىق / ئېنىق)",
    tool_eraser: "Eraser (Ctrl + E)",
    tool_brush_size: "چوتكا چوڭلۇقىنى تەڭشەڭ",
    tool_bucket: "تولدۇرۇڭ (Ctrl + F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Grid (Ctrl + Shift + B)",
    tool_rotate: "ئايلاندۇرۇش (Ctrl + Shift + R)",
    tool_flip_h: "Flip H (Ctrl + Shift + H)",
    tool_flip_v: "Flip V (Ctrl + Shift + V)",
    tool_transpose: "Transpose (Ctrl + Shift + T)",
    label_width: "كەڭلىك",
    label_height: "ئېگىزلىكى",
    label_frames: "رامكا سانى",
    label_animation: "Animation Style",
    label_background_color: "تەگلىك رەڭگى",
    label_interval: "ئارىلىق",
    tool_anim_config: "كارتون سەپلىمىسى",
    label_new_width: "يېڭى كەڭلىك",
    label_new_height: "يېڭى ئېگىزلىك",
    label_apply: "ئىلتىماس قىلىڭ",
    label_colors: "رەڭلەر",
    label_size: "چوڭلۇقى",
    label_tolerance: "كەڭ قورساقلىق",
    val_horizontal: "توغرىسىغا",
    val_vertical: "ۋېرتىكال",
    val_sequence: "تەرتىپ",
    val_bounce: "قاڭقىش",
    val_random: "ئىختىيارىي",
    val_solid: "قاتتىق",
    val_clear: "ئېنىق",
    action_add_sheet: "يېڭى جەدۋەل",
    action_import: "ئەكىرىش",
    action_export: "ئېكسپورت",
    action_sort_projects: "تەرتىپلەش",
    sort_date_old: "Oldest First",
    sort_date_new: "ئەڭ يېڭى بىرىنچى",
    sort_name_az: "ئىسمى (A-Z)",
    sort_name_za: "ئىسمى (Z-A)",
    action_new_sprite: "New Sprite",
    action_new_project: "يېڭى تۈر",
    modal_save_all_title: "بارلىق ئۆزگەرتىشلەرنى ساقلاڭ",
    modal_save_all_desc: "ساقلايدىغان مۈلۈكنى تاللاڭ:",
    modal_save_selected: "تاللانغاننى ساقلاش",
    action_saved: "ساقلاندى",
    modal_create_sprite_title: "يېڭى Sprite قۇر",
    modal_create_project_title: "يېڭى تۈر قۇرۇش",
    modal_add_sheet_title: "يېڭى جەدۋەل قوشۇڭ",
    modal_rename_sheet_title: "جەدۋەلنىڭ نامىنى ئۆزگەرتىش",
    modal_rename_sprite_title: "Sprite نىڭ نامىنى ئۆزگەرتىڭ",
    modal_delete_sprite_title: "Sprite نى ئۆچۈرۈڭ",
    modal_delete_project_title: "تۈرنى ئۆچۈرۈڭ",
    modal_delete_sheet_title: "جەدۋەلنى ئۆچۈرۈڭ",
    placeholder_sprite_name: "ئىسمى",
    placeholder_project_name: "ئىسمى",
    placeholder_sheet_name: "ئىسمى",
    placeholder_new_name: "يېڭى ئىسىم",
    action_create: "قۇر",
    action_add: "قوش",
    action_rename: "ئىسىم ئۆزگەرتىش",
    action_duplicate: "كۆپەيتىلگەن",
    action_delete: "ئۆچۈرۈش",
    action_cancel: "بىكار قىلىش",
    confirm_delete_sprite: "بۇ چاستوتىنى ئۆچۈرمەكچىمۇ؟",
    confirm_delete_project: "بۇ تۈرنى ئۆچۈرمەكچىمۇ؟ بارلىق پۈركۈشلەر چىقىرىۋېتىلىدۇ.",
    confirm_delete_sheet: "بۇ جەدۋەلنى ئۆچۈرمەكچىمۇ؟",
    err_select_sprite: "ئالدى بىلەن بىر تال چاچنى تاللاڭ.",
    err_select_project: "ئالدى بىلەن بىر تۈرنى تاللاڭ.",
    err_name_empty: "ئىسىم قۇرۇق بولمايدۇ.",
    err_sprite_exists: "بۇ ئىسىم بىلەن بىر sprite ئاللىبۇرۇن مەۋجۇت.",
    err_project_exists: "بۇ ئىسىم بىلەن بىر تۈر مەۋجۇت.",
    err_no_content: "ساقلايدىغان مەزمۇن يوق.",
    err_no_changes: "ساقلاشقا ئۆزگەرتىش يوق.",
    err_delete_last_sheet: "ئاخىرقى جەدۋەلنى ئۆچۈرگىلى بولمايدۇ.",
    err_extract_frames: "ھېچقانداق رامكىنى چىقىرىۋېتەلمىدى.",
    err_indexeddb: "يەرلىكتە ساقلىيالمىدى. تور كۆرگۈچىڭىز IndexedDB نى قوللىماسلىقى مۇمكىن.",
    msg_upload_success: "يۈكلەش مۇۋەپپەقىيەتلىك: {0}",
    msg_upload_failed: "يوللاش مەغلۇپ بولدى: {0}",
    msg_save_success: "مۇۋەپپەقىيەتلىك تېجەڭ.",
    msg_saving: "تېجەش ...",
    msg_multi_save_result: "{0} مۈلۈكنى تېجەپ قالدى. {1} مەغلۇبىيەت.",
    menu_title: "تىزىملىك",
    menu_save: "ساقلاش",
    menu_save_all: "ھەممىنى ساقلاڭ",
    menu_support: "ياردەم بىلەن ئالاقىلىشىڭ",
    label_local_storage: "يەرلىك ساقلاش",
    label_sign_in: "تىزىملىتىڭ",
    modal_export_title: "Exrite Sprite",
    label_filename: "ھۆججەت ئىسمى",
    label_format: "فورماتى",
    action_export_confirm: "ئېكسپورت",
};

export default translations;
